// eslint-disable-next-line import/prefer-default-export
export const SUPPORT_EMAIL = 'support@uflexreward.com';
